import { useLocation } from 'react-router-dom';

import { usePageTitle } from '@app/hooks/usePageTitle';
import DashboardWidget from '@widgets/dashboard';

const DashboardPage = () => {
  const location = useLocation();
  const isNewDashboard = location.pathname.includes('new');

  usePageTitle(isNewDashboard ? 'Dashboard New' : 'Dashboard');

  return <DashboardWidget />;
};

export default DashboardPage;
